import React from "react";

export type AddGiftCardScreenContextType = {
  productId: string;
};

export const AddGiftCardScreenContext = React.createContext<
  AddGiftCardScreenContextType | undefined
>(undefined);
